/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Payment_Choice_Modal_Pay_Now_ButtonInputs */

const es_components_payment_choice_modal_pay_now_button = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a pagar`)
};

const en_components_payment_choice_modal_pay_now_button = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to payment`)
};

/**
* | output |
* | --- |
* | "Go to payment" |
*
* @param {Components_Payment_Choice_Modal_Pay_Now_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_payment_choice_modal_pay_now_button = /** @type {((inputs?: Components_Payment_Choice_Modal_Pay_Now_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Payment_Choice_Modal_Pay_Now_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_payment_choice_modal_pay_now_button(inputs)
	return en_components_payment_choice_modal_pay_now_button(inputs)
});
export { components_payment_choice_modal_pay_now_button as "components.payment_choice_modal.pay_now_button" }